import { useNavigate } from "react-router-dom";
import {
    Card, CardHeader,
    CardTitle, CardBody,
    Button} from "reactstrap"

function ServerError() {
    const navigation = useNavigate();

    return (
      <>
            <div className="content">
                <Card>
                    <CardHeader>
                        <CardTitle tag="h4"></CardTitle>
                    </CardHeader>
                    <CardBody>
                        <div className="typography-line">
                        <h1 className="title">Goodnet</h1>
                        <h6>Server Has Been Crashed Please Contact Administrator</h6>
                        <p>500 Internal Server Error</p>
                            <Button
                                size="lg"
                                className="mb-3 btn-round text-white font-weight-bold bg-dark"
                                onClick={() => navigation('/')}
                            >Continue</Button>
                        </div>
                    </CardBody>
                </Card>
            </div>
         </>
    )
}

export default ServerError